module.exports = __webpack_public_path__ + "img/expostyle_1334_hawaiian_ocean_pantone632c.18b16fc4.jpg";